export const SUSTAINABILITY_GROUP_ID = 'STAIRCASE_TO_SUSTAINABILITY';
export const sustainabilityBadgeIcon = 'sustainability-3';

const TIER_ID_PATTERN = /SUSTAINABILITY_TIER_(\d+)/;

const sustainabilityTiers = {
  SUSTAINABILITY_TIER_0: 0,
  SUSTAINABILITY_TIER_1: 1,
  SUSTAINABILITY_TIER_2: 2,
  SUSTAINABILITY_TIER_3: 3,
  SUSTAINABILITY_TIER_4: 4,
};

function getSustainabilityTierNumber(categoryId) {
  const match = String(categoryId || '').match(TIER_ID_PATTERN);
  return match ? Number(match[1]) : null;
}

export function isDisplayableSustainabilityTier(categoryId) {
  const tier = getSustainabilityTierNumber(categoryId);
  return tier !== null && tier >= 1;
}

// Single badge for certified properties. Tier 0 is present on the payload but
// must not be shown (badge and tracking).
export function getSustainabilityCategory(categories) {
  const category
    = categories?.find((group) => group.group_category_id === SUSTAINABILITY_GROUP_ID)?.categories?.[0] || null;

  if (!category || !isDisplayableSustainabilityTier(category.category_id)) {
    return null;
  }

  return category;
}

export default sustainabilityTiers;
